'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./~/har-validator/~/ajv/lib/compile/schema_obj.js
// module id = LsSK
// module chunks = 1